import { NavLink } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthProvider';
import './AppShell.css';

const BASE_NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard', icon: '▤' },
  { to: '/scan', label: 'Scan', icon: '◎' },
  { to: '/leads', label: 'Leads', icon: '☰' }
] as const;

const TEAM_NAV_ITEM = { to: '/team', label: 'Team', icon: '◎' } as const;

export function BottomNav() {
  const { user } = useAuth();
  const navItems = user?.role === 'ExhibitorAdmin' ? [...BASE_NAV_ITEMS, TEAM_NAV_ITEM] : BASE_NAV_ITEMS;

  return (
    <nav className="bottom-nav" aria-label="Primary">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `bottom-nav__item${isActive ? ' bottom-nav__item--active' : ''}`}
        >
          <span className="bottom-nav__icon" aria-hidden="true">
            {item.icon}
          </span>
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}